module.exports = __webpack_public_path__ + "media/images/flags/hn-f53ee3d65d19c9dd755eb992a52ae727.svg";